var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner flexColumn"},[_c('top-tab',{attrs:{"topBarDatas":_vm.topBarDatas}}),_c('div',{staticClass:"contentBox"},[_c('box-border',{attrs:{"title":"工作督办"}},[_c('echart-module',{ref:"workSupervise",attrs:{"option":_vm.workSupervise}})],1),_c('box-border',{attrs:{"title":"业主回复意见"}},[_c('echart-module',{ref:"OwnerReply",attrs:{"option":_vm.OwnerReply}})],1),_c('box-border',{attrs:{"title":"项目文档跟踪","boxStyle":{
                'grid-column': '3 / span 2'
            }}},[_c('echart-module',{ref:"tracking",staticStyle:{"height":"100%","width":"100%"},attrs:{"option":_vm.tracking}})],1),_c('box-border',{attrs:{"title":"文档类型跟踪","boxStyle":{
                'grid-column': '1 / span 2'
            }}},[_c('Table',_vm._b({attrs:{"tableStyle":{
                    height: '100%',
                }}},'Table',_vm.typeTableData,false))],1),_c('box-border',{attrs:{"title":"公司文档跟踪","boxStyle":{
                'grid-column': '3 / span 2'
            }}},[_c('Table',_vm._b({attrs:{"tableStyle":{
                    height: '100%',
                }}},'Table',_vm.companyTableData,false))],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }